export default __webpack_public_path__ + "static/media/fire_girl.40194fbc.png";